/** Минимальный тип пользователя Firebase Auth для расчёта имени без зависимости от полного типа SDK. */
export type AuthUserLike = {
  email?: string | null;
  displayName?: string | null;
};

/**
 * Имя по умолчанию: сначала displayName из Google/провайдера, иначе часть email до @.
 */
export function defaultDisplayNameFromAuth(user: AuthUserLike | null | undefined): string {
  if (!user) return '';
  const fromProvider = user.displayName?.trim();
  if (fromProvider) return fromProvider;
  const email = user.email?.trim();
  if (!email) return '';
  const at = email.indexOf('@');
  return at > 0 ? email.slice(0, at) : email;
}

/**
 * Значение для формы: сохранённое в профиле (Firestore / смерженное userData), иначе дефолт из Auth.
 */
export function resolvedDisplayNameForForm(
  firestoreDisplayName: string | null | undefined,
  authUser: AuthUserLike | null | undefined
): string {
  const stored = typeof firestoreDisplayName === 'string' ? firestoreDisplayName.trim() : '';
  if (stored) return stored;
  return defaultDisplayNameFromAuth(authUser);
}

/** Инициалы для аватара (список контактов, шапка чата). */
export function displayNameInitials(label: string): string {
  const t = label.trim();
  if (!t) return '?';
  const w = t.split(/\s+/).filter(Boolean);
  if (w.length >= 2) {
    const a = w[0][0] ?? '';
    const b = w[1][0] ?? '';
    return (a + b).toUpperCase().slice(0, 2);
  }
  return t.slice(0, 2).toUpperCase();
}
